export const multiScreenModeActions = {
  previousSlide: 'previous',
  nextSlide: 'next',
  initialize: 'init',
};
